import { useSearchParams } from 'react-router-dom';
import { PAGINATION_DEFAULT_LIMIT } from 'shared/constants/paginations';

interface IPaginationParams {
  page: number;
  limit: number;
  handlePageChange: (page: number, pageSize?: number) => void;
}

interface IPaginationParamsProps {
  fixLimit?: number;
}

export const usePaginationParams = ({ fixLimit }: IPaginationParamsProps = {}): IPaginationParams => {
  const [searchParams, setSearchParams] = useSearchParams();

  const page = Number(searchParams.get('page')) || 1;
  const limit = fixLimit || Number(searchParams.get('limit')) || PAGINATION_DEFAULT_LIMIT;

  const handlePageChange = (page: number, pageSize?: number) => {
    if (pageSize && pageSize !== limit) {
      searchParams.set('page', String(1));
      searchParams.set('limit', String(pageSize));
    } else {
      searchParams.set('page', String(page));
    }
    window.scrollTo({ top: 0 });
    setSearchParams(searchParams);
  };

  return { page, limit, handlePageChange };
};
